export const redirectToNotFound = () => ({ type: NavigationActionType.NotFound });
export const redirectToHome = () => ({ type: NavigationActionType.Home });

export enum NavigationActionType {
  NotFound = 'pelo/redirect/NotFound',
  Home = 'pelo/redirect/Home',
}
